import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface RecoverPasswordFormProps {
  onSubmit: (email: string) => void;
  onCancel: () => void;
  loading?: boolean;
  error?: string;
  success?: boolean;
}

export const RecoverPasswordForm = ({
  onSubmit,
  onCancel,
  loading,
  error,
  success,
}: RecoverPasswordFormProps) => {
  const [t] = useTranslation('login');
  const [email, setEmail] = useState('');

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      <h2 className="text-lg font-semibold">{t('forgot_password')}</h2>
      <p className="text-center text-sm text-gray-600">
        {t('forgot_password_instructions')}
      </p>
      <input
        type="email"
        className="input input-bordered w-full"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('placeholder_email')}
        autoComplete="email"
      />
      {error && <div className="text-center text-sm text-red-500">{error}</div>}
      {success && (
        <div className="text-center text-sm text-green-500">
          {t('email_sent', { email })}
        </div>
      )}
      <div className="flex gap-2">
        <button
          className="btn btn-primary rounded-full"
          onClick={onCancel}
          disabled={loading}
        >
          {t('cancel')}
        </button>
        <button
          className="btn btn-primary rounded-full"
          onClick={() => onSubmit(email)}
          disabled={loading || !email}
        >
          {t('send')}
        </button>
      </div>
    </div>
  );
};
